module.exports = __webpack_public_path__ + "img/20211017_095947.be09ca56.jpg";